import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from 'ionic-angular';

import { PageHeroComponent } from './page-hero/page-hero';
import { AppQuestionnaireComponent } from './app-questionnaire/app-questionnaire';

@NgModule({
  declarations: [PageHeroComponent, AppQuestionnaireComponent],
  imports: [CommonModule, IonicModule],
  exports: [PageHeroComponent, AppQuestionnaireComponent]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts